

import { createSlice } from "@reduxjs/toolkit";
import { IOrder } from "../interface/IOrder";

const initialState: IOrder | null = null;

const selectOrderData = createSlice({
    name: "selectOrderData",
    initialState,
    reducers: {
        setSelectOrderDataInStore: (state: IOrder | null, action: any | null) => {
            return action.payload;
        }
    },
});


export const { setSelectOrderDataInStore } = selectOrderData.actions;

export default selectOrderData.reducer;
